export const contactsData = {
    email: 'koshikesai25@gmail.com',
    phone: '8465984848',
    address: 'Menlo Park, California, United States - 673822 ',

    sheetAPI: ''
}